import { FetchAPI } from "../Main/fetchAPI";
import { CLIENT } from "../constants";
import { GetInsuranceProperties } from "./insuranceAuthorizationProperties";

export const Insurances = {
    getInsurances: ({ includeOutOfNetwork }: GetInsuranceProperties) => {

        const query = new URLSearchParams();
        if (typeof includeOutOfNetwork === 'boolean') query.set("includeOutOfNetwork", `${includeOutOfNetwork}`)
        return FetchAPI.getJson({
            urlStr: `${CLIENT}/insurances?${query.toString()}`
        })
    },
}
